import React, { useState } from 'react'
import { Box, Tabs, Tab, useTheme, useMediaQuery } from '@mui/material'
import { Newspaper, Article, LinkedIn, Block } from '@mui/icons-material'
import NewsManagementTab from './NewsManagementTab'
import DocumentsTab from './DocumentsTab'
import LinkedInTab from './LinkedInTab'
import StrategicallyRejectedTab from './StrategicallyRejectedTab'

const SUB_TAB_NAMES = ['news-management', 'documents', 'linkedin', 'strategically-rejected']

const getInitialSubTab = () => {
  const params = new URLSearchParams(window.location.search)
  const sub = params.get('subtab')
  const idx = SUB_TAB_NAMES.indexOf(sub)
  return idx >= 0 ? idx : 0
}

const NewsReviewTab = ({ showNotification, onCountChange }) => {
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'))
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const [subTabValue, setSubTabValue] = useState(getInitialSubTab)

  const handleSubTabChange = (event, newValue) => {
    setSubTabValue(newValue)
    const params = new URLSearchParams(window.location.search)
    params.set('subtab', SUB_TAB_NAMES[newValue])
    params.delete('subTab')
    params.delete('blogId')
    window.history.replaceState({}, '', `${window.location.pathname}?${params}`)
  }

  return (
    <Box>
      <Tabs
        value={subTabValue}
        onChange={handleSubTabChange}
        variant={isSmallScreen ? 'scrollable' : 'standard'}
        scrollButtons={isSmallScreen ? 'auto' : false}
        allowScrollButtonsMobile
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
          mb: 3,
          '& .MuiTabs-scroller': {
            overflowX: isSmallScreen ? 'auto !important' : 'hidden',
          },
          '& .MuiTab-root': {
            textTransform: 'none',
            fontSize: { xs: '0.8rem', sm: '0.9rem', md: '1rem' },
            fontWeight: 500,
            minWidth: { xs: 130, sm: 155, md: 0 },
            minHeight: { xs: 72, sm: 76, md: 48 },
            px: { xs: 1.25, sm: 1.75, md: 2 },
            whiteSpace: 'nowrap',
            flexShrink: 0,
          },
          '& .MuiTab-root .MuiSvgIcon-root': {
            fontSize: { xs: '1.15rem', sm: '1.3rem', md: '1.2rem' },
          },
          '& .MuiTab-iconWrapper': {
            marginBottom: { xs: '6px !important', sm: '0 !important', md: '0 !important' },
          },
          '& .MuiTab-root.Mui-selected': {
            color: '#232536',
          },
          '& .MuiTabs-indicator': {
            backgroundColor: '#232536',
          },
          '& .MuiTabs-scrollButtons': {
            color: '#232536',
            '&.Mui-disabled': { opacity: 0.3 },
          },
        }}
      >
        <Tab
          icon={<Newspaper />}
          iconPosition={isMobile ? 'top' : 'start'}
          label='News Management'
        />
        <Tab
          icon={<Article />}
          iconPosition={isMobile ? 'top' : 'start'}
          label='New Documents'
        />
        <Tab
          icon={<LinkedIn />}
          iconPosition={isMobile ? 'top' : 'start'}
          label='LinkedIn'
        />
        <Tab
          icon={<Block />}
          iconPosition={isMobile ? 'top' : 'start'}
          label='Strategically Rejected'
        />
      </Tabs>

      <Box>
        {subTabValue === 0 && (
          <NewsManagementTab
            showNotification={showNotification}
            onCountChange={onCountChange}
          />
        )}
        {subTabValue === 1 && (
          <DocumentsTab showNotification={showNotification} />
        )}
        {subTabValue === 2 && <LinkedInTab />}
        {subTabValue === 3 && (
          <StrategicallyRejectedTab showNotification={showNotification} />
        )}
      </Box>
    </Box>
  )
}

export default NewsReviewTab
